// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-tjcx-zzbdblcx-index-main_right_content-2Fa87","table":"components-tjcx-zzbdblcx-index-table-3cRRT"};


//////////////////
// WEBPACK FOOTER
// ./components/tjcx/zzbdblcx/index.css
// module id = 569
// module chunks = 0